define('HidePaymentMethods.EntryPoint',
  [
    'OrderWizard.Module.PaymentMethod.Selector',
    'underscore'
  ],
  function (
    OrderWizardModulePaymentMethodSelector,
    _
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp() {
        _.extend(OrderWizardModulePaymentMethodSelector.prototype, {
          initialize: _.wrap(OrderWizardModulePaymentMethodSelector.prototype.initialize, function (fn) {
            fn.apply(this, _.toArray(arguments).slice(1));

            this.modules = _.reject(this.modules, function (module) {
              return module.type === 'creditcard';
            });
          })
        });
      }
    };
  }
);
